import React, { type FC } from 'react';

import type { ButtonProps, SegmentedButtonsProps } from './SegmentedButtons.types';

import styles from './Styles/Default.module.css';

const SegmentedButtons: FC<SegmentedButtonsProps> = React.forwardRef<
  HTMLDivElement,
  SegmentedButtonsProps
>(({ className, currentValue, buttons, dataTestId, onChange, wideView, ...restProps }, ref) => {
  const isLinks = buttons.some(btn => btn.href);

  return (
    <div
      className={`${styles.wrapper} ${wideView ? styles.isWideView : ''} ${className}`}
      data-test-id={dataTestId}
      ref={ref}
      role={isLinks ? undefined : 'radiogroup'}
      {...restProps}
    >
      {buttons.map(btn => {
        const isActive = currentValue === btn.value;

        if (btn.href) {
          return (
            <a
              aria-current={isActive || undefined}
              className={styles.btn}
              data-test-id={btn.dataTestId}
              href={btn.href}
              key={btn.label}
              onClick={event => {
                if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
                if (btn.value) onChange(btn.value);
              }}
            >
              {btn.icon}
              {btn.label}
            </a>
          );
        }

        return (
          <button
            aria-checked={isActive}
            aria-label={btn.label}
            className={styles.btn}
            data-test-id={btn.dataTestId}
            disabled={btn.isDisabled}
            key={btn.label}
            onClick={() => {
              if (!isActive && btn.value) onChange(btn.value);
            }}
            role="radio"
          >
            {btn.icon}
            {btn.label}
          </button>
        );
      })}
    </div>
  );
});

SegmentedButtons.displayName = 'SegmentedButtons';

export { SegmentedButtons };
export type { ButtonProps };
